import React from 'react';
import '../styles/AnimatedLogo.css';

const AnimatedLogo = () => {
    return (
        <div className="logo-container">
            <h1 className="animated-logo">📽️Nanin 🎞️ Nan 🎬</h1>
        </div>
    );
};

export default AnimatedLogo;

/*<p className="animated-tagline">La pellicule de vos émotions 🎬</p>*/